/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AgelessMarketingDeploymentChecklistProgressForPlatformRetrievedResponse,
  DefineAgelessShortLinkRequest,
  DisplayAgelessShortLink,
  DisplayAgelessShortLinkCatalogResponse,
  DisplayAgelessWebsiteEmbedSettingsResponse,
  DisplayAllowAnonAgelessMarketingContext,
  DisplayValidatedAgelessMarketingSetupTokenResponse,
  GetSetupLinkScopeParams,
  GetSharedWebsiteEmbedSettingsParams,
  ProblemDetails,
  ResolveAgelessShortLinkParams,
  SetAllowedOriginsForAgelessWebsiteEmbedViaSetupLinkRequest
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary What this link is scoped to: the platform and its current embed state, so the page can
show the setup wizard rather than the "an administrator must be signed in" notice.
 */
export const getSetupLinkScope = (
    params?: GetSetupLinkScopeParams,
 signal?: AbortSignal
) => {


      return customAxios<DisplayValidatedAgelessMarketingSetupTokenResponse>(
      {url: `/api/v1/ageless/marketing/setup-link`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetSetupLinkScopeQueryKey = (params?: GetSetupLinkScopeParams,) => {
    return [
    `/api/v1/ageless/marketing/setup-link`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSetupLinkScopeQueryOptions = <TData = Awaited<ReturnType<typeof getSetupLinkScope>>, TError = ErrorType<ProblemDetails>>(params?: GetSetupLinkScopeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSetupLinkScope>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSetupLinkScopeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSetupLinkScope>>> = ({ signal }) => getSetupLinkScope(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSetupLinkScope>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSetupLinkScopeQueryResult = NonNullable<Awaited<ReturnType<typeof getSetupLinkScope>>>
export type GetSetupLinkScopeQueryError = ErrorType<ProblemDetails>


export function useGetSetupLinkScope<TData = Awaited<ReturnType<typeof getSetupLinkScope>>, TError = ErrorType<ProblemDetails>>(
 params: undefined |  GetSetupLinkScopeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSetupLinkScope>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSetupLinkScope>>,
          TError,
          Awaited<ReturnType<typeof getSetupLinkScope>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSetupLinkScope<TData = Awaited<ReturnType<typeof getSetupLinkScope>>, TError = ErrorType<ProblemDetails>>(
 params?: GetSetupLinkScopeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSetupLinkScope>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSetupLinkScope>>,
          TError,
          Awaited<ReturnType<typeof getSetupLinkScope>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSetupLinkScope<TData = Awaited<ReturnType<typeof getSetupLinkScope>>, TError = ErrorType<ProblemDetails>>(
 params?: GetSetupLinkScopeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSetupLinkScope>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What this link is scoped to: the platform and its current embed state, so the page can
show the setup wizard rather than the "an administrator must be signed in" notice.
 */

export function useGetSetupLinkScope<TData = Awaited<ReturnType<typeof getSetupLinkScope>>, TError = ErrorType<ProblemDetails>>(
 params?: GetSetupLinkScopeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSetupLinkScope>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSetupLinkScopeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSetupLinkScopeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSetupLinkScope>>, TError = ErrorType<ProblemDetails>>(params?: GetSetupLinkScopeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSetupLinkScope>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSetupLinkScopeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSetupLinkScope>>> = ({ signal }) => getSetupLinkScope(params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSetupLinkScope>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSetupLinkScopeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSetupLinkScope>>>
export type GetSetupLinkScopeSuspenseQueryError = ErrorType<ProblemDetails>


export function useGetSetupLinkScopeSuspense<TData = Awaited<ReturnType<typeof getSetupLinkScope>>, TError = ErrorType<ProblemDetails>>(
 params: undefined |  GetSetupLinkScopeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSetupLinkScope>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSetupLinkScopeSuspense<TData = Awaited<ReturnType<typeof getSetupLinkScope>>, TError = ErrorType<ProblemDetails>>(
 params?: GetSetupLinkScopeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSetupLinkScope>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSetupLinkScopeSuspense<TData = Awaited<ReturnType<typeof getSetupLinkScope>>, TError = ErrorType<ProblemDetails>>(
 params?: GetSetupLinkScopeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSetupLinkScope>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What this link is scoped to: the platform and its current embed state, so the page can
show the setup wizard rather than the "an administrator must be signed in" notice.
 */

export function useGetSetupLinkScopeSuspense<TData = Awaited<ReturnType<typeof getSetupLinkScope>>, TError = ErrorType<ProblemDetails>>(
 params?: GetSetupLinkScopeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSetupLinkScope>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSetupLinkScopeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Replaces the website-embed allowlist for this link's platform and enables the embed.
This is the only platform state a setup-link holder can change.
 */
export const setSetupLinkWebsiteEmbedAllowedOrigins = (
    setAllowedOriginsForAgelessWebsiteEmbedViaSetupLinkRequest: SetAllowedOriginsForAgelessWebsiteEmbedViaSetupLinkRequest,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/marketing/setup-link/website-embed/allowed-origins`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAllowedOriginsForAgelessWebsiteEmbedViaSetupLinkRequest, signal
    },
      );
    }




export const getSetSetupLinkWebsiteEmbedAllowedOriginsMutationKey = () => ['setSetupLinkWebsiteEmbedAllowedOrigins'] as const;

export const getSetSetupLinkWebsiteEmbedAllowedOriginsMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSetupLinkWebsiteEmbedAllowedOrigins>>, TError,SetSetupLinkWebsiteEmbedAllowedOriginsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setSetupLinkWebsiteEmbedAllowedOrigins>>, TError,SetSetupLinkWebsiteEmbedAllowedOriginsMutationVariables, TContext> => {

const mutationKey = getSetSetupLinkWebsiteEmbedAllowedOriginsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSetupLinkWebsiteEmbedAllowedOrigins>>, SetSetupLinkWebsiteEmbedAllowedOriginsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setSetupLinkWebsiteEmbedAllowedOrigins(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSetupLinkWebsiteEmbedAllowedOriginsMutationResult = NonNullable<Awaited<ReturnType<typeof setSetupLinkWebsiteEmbedAllowedOrigins>>>
    export type SetSetupLinkWebsiteEmbedAllowedOriginsMutationBody = SetAllowedOriginsForAgelessWebsiteEmbedViaSetupLinkRequest
    export type SetSetupLinkWebsiteEmbedAllowedOriginsMutationError = ErrorType<ProblemDetails>
    export type SetSetupLinkWebsiteEmbedAllowedOriginsMutationVariables = {data: SetAllowedOriginsForAgelessWebsiteEmbedViaSetupLinkRequest}

    /**
 * @summary Replaces the website-embed allowlist for this link's platform and enables the embed.
This is the only platform state a setup-link holder can change.
 */
export const useSetSetupLinkWebsiteEmbedAllowedOrigins = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSetupLinkWebsiteEmbedAllowedOrigins>>, TError,SetSetupLinkWebsiteEmbedAllowedOriginsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setSetupLinkWebsiteEmbedAllowedOrigins>>,
        TError,
        SetSetupLinkWebsiteEmbedAllowedOriginsMutationVariables,
        TContext
      > => {
      return useMutation(getSetSetupLinkWebsiteEmbedAllowedOriginsMutationOptions(options), queryClient);
    }
    /**
 * @summary The practice's Ageless deployment checklist. The person doing the deployment is the one
who can honestly tick these off, which is why the link grants it.
 */
export const getSetupLinkDeploymentChecklistProgress = (

 signal?: AbortSignal
) => {


      return customAxios<AgelessMarketingDeploymentChecklistProgressForPlatformRetrievedResponse>(
      {url: `/api/v1/ageless/marketing/setup-link/deployment-checklist`, method: 'GET', signal
    },
      );
    }




export const getGetSetupLinkDeploymentChecklistProgressQueryKey = () => {
    return [
    `/api/v1/ageless/marketing/setup-link/deployment-checklist`
    ] as const;
    }


export const getGetSetupLinkDeploymentChecklistProgressQueryOptions = <TData = Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError = ErrorType<ProblemDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSetupLinkDeploymentChecklistProgressQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>> = ({ signal }) => getSetupLinkDeploymentChecklistProgress(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSetupLinkDeploymentChecklistProgressQueryResult = NonNullable<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>>
export type GetSetupLinkDeploymentChecklistProgressQueryError = ErrorType<ProblemDetails>


export function useGetSetupLinkDeploymentChecklistProgress<TData = Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError = ErrorType<ProblemDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>,
          TError,
          Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSetupLinkDeploymentChecklistProgress<TData = Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>,
          TError,
          Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSetupLinkDeploymentChecklistProgress<TData = Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The practice's Ageless deployment checklist. The person doing the deployment is the one
who can honestly tick these off, which is why the link grants it.
 */

export function useGetSetupLinkDeploymentChecklistProgress<TData = Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSetupLinkDeploymentChecklistProgressQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSetupLinkDeploymentChecklistProgressSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError = ErrorType<ProblemDetails>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSetupLinkDeploymentChecklistProgressQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>> = ({ signal }) => getSetupLinkDeploymentChecklistProgress(signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSetupLinkDeploymentChecklistProgressSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>>
export type GetSetupLinkDeploymentChecklistProgressSuspenseQueryError = ErrorType<ProblemDetails>


export function useGetSetupLinkDeploymentChecklistProgressSuspense<TData = Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError = ErrorType<ProblemDetails>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSetupLinkDeploymentChecklistProgressSuspense<TData = Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSetupLinkDeploymentChecklistProgressSuspense<TData = Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The practice's Ageless deployment checklist. The person doing the deployment is the one
who can honestly tick these off, which is why the link grants it.
 */

export function useGetSetupLinkDeploymentChecklistProgressSuspense<TData = Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSetupLinkDeploymentChecklistProgress>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSetupLinkDeploymentChecklistProgressSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Marks a deployment checklist item complete on behalf of this link's holder.
 */
export const markSetupLinkChecklistItemAsCompleted = (
    itemSlug: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/marketing/setup-link/deployment-checklist/items/${itemSlug}/complete`, method: 'PUT', signal
    },
      );
    }




export const getMarkSetupLinkChecklistItemAsCompletedMutationKey = () => ['markSetupLinkChecklistItemAsCompleted'] as const;

export const getMarkSetupLinkChecklistItemAsCompletedMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsCompleted>>, TError,MarkSetupLinkChecklistItemAsCompletedMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsCompleted>>, TError,MarkSetupLinkChecklistItemAsCompletedMutationVariables, TContext> => {

const mutationKey = getMarkSetupLinkChecklistItemAsCompletedMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsCompleted>>, MarkSetupLinkChecklistItemAsCompletedMutationVariables> = (props) => {
          const {itemSlug} = props ?? {};

          return  markSetupLinkChecklistItemAsCompleted(itemSlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkSetupLinkChecklistItemAsCompletedMutationResult = NonNullable<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsCompleted>>>

    export type MarkSetupLinkChecklistItemAsCompletedMutationError = ErrorType<ProblemDetails>
    export type MarkSetupLinkChecklistItemAsCompletedMutationVariables = {itemSlug: string}

    /**
 * @summary Marks a deployment checklist item complete on behalf of this link's holder.
 */
export const useMarkSetupLinkChecklistItemAsCompleted = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsCompleted>>, TError,MarkSetupLinkChecklistItemAsCompletedMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markSetupLinkChecklistItemAsCompleted>>,
        TError,
        MarkSetupLinkChecklistItemAsCompletedMutationVariables,
        TContext
      > => {
      return useMutation(getMarkSetupLinkChecklistItemAsCompletedMutationOptions(options), queryClient);
    }
    /**
 * @summary Clears a deployment checklist item on behalf of this link's holder.
 */
export const markSetupLinkChecklistItemAsIncomplete = (
    itemSlug: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/ageless/marketing/setup-link/deployment-checklist/items/${itemSlug}/incomplete`, method: 'PUT', signal
    },
      );
    }




export const getMarkSetupLinkChecklistItemAsIncompleteMutationKey = () => ['markSetupLinkChecklistItemAsIncomplete'] as const;

export const getMarkSetupLinkChecklistItemAsIncompleteMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsIncomplete>>, TError,MarkSetupLinkChecklistItemAsIncompleteMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsIncomplete>>, TError,MarkSetupLinkChecklistItemAsIncompleteMutationVariables, TContext> => {

const mutationKey = getMarkSetupLinkChecklistItemAsIncompleteMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsIncomplete>>, MarkSetupLinkChecklistItemAsIncompleteMutationVariables> = (props) => {
          const {itemSlug} = props ?? {};

          return  markSetupLinkChecklistItemAsIncomplete(itemSlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkSetupLinkChecklistItemAsIncompleteMutationResult = NonNullable<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsIncomplete>>>

    export type MarkSetupLinkChecklistItemAsIncompleteMutationError = ErrorType<ProblemDetails>
    export type MarkSetupLinkChecklistItemAsIncompleteMutationVariables = {itemSlug: string}

    /**
 * @summary Clears a deployment checklist item on behalf of this link's holder.
 */
export const useMarkSetupLinkChecklistItemAsIncomplete = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markSetupLinkChecklistItemAsIncomplete>>, TError,MarkSetupLinkChecklistItemAsIncompleteMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markSetupLinkChecklistItemAsIncomplete>>,
        TError,
        MarkSetupLinkChecklistItemAsIncompleteMutationVariables,
        TContext
      > => {
      return useMutation(getMarkSetupLinkChecklistItemAsIncompleteMutationOptions(options), queryClient);
    }
    /**
 * @summary The short link for a flow and attribution, minted on this link's platform — the same
retrieve-or-define the signed-in wizard uses, so a web developer working from the setup
link gets the same code an admin would.
 */
export const defineSetupLinkAgelessShortLink = (
    defineAgelessShortLinkRequest: DefineAgelessShortLinkRequest,
 signal?: AbortSignal
) => {


      return customAxios<DisplayAgelessShortLink>(
      {url: `/api/v1/ageless/marketing/setup-link/short-links`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: defineAgelessShortLinkRequest, signal
    },
      );
    }




export const getDefineSetupLinkAgelessShortLinkMutationKey = () => ['defineSetupLinkAgelessShortLink'] as const;

export const getDefineSetupLinkAgelessShortLinkMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof defineSetupLinkAgelessShortLink>>, TError,DefineSetupLinkAgelessShortLinkMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof defineSetupLinkAgelessShortLink>>, TError,DefineSetupLinkAgelessShortLinkMutationVariables, TContext> => {

const mutationKey = getDefineSetupLinkAgelessShortLinkMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof defineSetupLinkAgelessShortLink>>, DefineSetupLinkAgelessShortLinkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  defineSetupLinkAgelessShortLink(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DefineSetupLinkAgelessShortLinkMutationResult = NonNullable<Awaited<ReturnType<typeof defineSetupLinkAgelessShortLink>>>
    export type DefineSetupLinkAgelessShortLinkMutationBody = DefineAgelessShortLinkRequest
    export type DefineSetupLinkAgelessShortLinkMutationError = ErrorType<ProblemDetails>
    export type DefineSetupLinkAgelessShortLinkMutationVariables = {data: DefineAgelessShortLinkRequest}

    /**
 * @summary The short link for a flow and attribution, minted on this link's platform — the same
retrieve-or-define the signed-in wizard uses, so a web developer working from the setup
link gets the same code an admin would.
 */
export const useDefineSetupLinkAgelessShortLink = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof defineSetupLinkAgelessShortLink>>, TError,DefineSetupLinkAgelessShortLinkMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof defineSetupLinkAgelessShortLink>>,
        TError,
        DefineSetupLinkAgelessShortLinkMutationVariables,
        TContext
      > => {
      return useMutation(getDefineSetupLinkAgelessShortLinkMutationOptions(options), queryClient);
    }
    /**
 * @summary Practice identity, subdomain, active clinics, and brand color for the Ageless Marketing
page when it is viewed without a session.
 */
export const getAgelessMarketingContext = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayAllowAnonAgelessMarketingContext>(
      {url: `/api/v1/ageless/marketing/platforms/${platformId}/context`, method: 'GET', signal
    },
      );
    }




export const getGetAgelessMarketingContextQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/marketing/platforms/${platformId}/context`
    ] as const;
    }


export const getGetAgelessMarketingContextQueryOptions = <TData = Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError = ErrorType<ProblemDetails>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgelessMarketingContextQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgelessMarketingContext>>> = ({ signal }) => getAgelessMarketingContext(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAgelessMarketingContextQueryResult = NonNullable<Awaited<ReturnType<typeof getAgelessMarketingContext>>>
export type GetAgelessMarketingContextQueryError = ErrorType<ProblemDetails>


export function useGetAgelessMarketingContext<TData = Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgelessMarketingContext>>,
          TError,
          Awaited<ReturnType<typeof getAgelessMarketingContext>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgelessMarketingContext<TData = Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgelessMarketingContext>>,
          TError,
          Awaited<ReturnType<typeof getAgelessMarketingContext>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgelessMarketingContext<TData = Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Practice identity, subdomain, active clinics, and brand color for the Ageless Marketing
page when it is viewed without a session.
 */

export function useGetAgelessMarketingContext<TData = Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAgelessMarketingContextQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAgelessMarketingContextSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError = ErrorType<ProblemDetails>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgelessMarketingContextQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgelessMarketingContext>>> = ({ signal }) => getAgelessMarketingContext(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAgelessMarketingContextSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAgelessMarketingContext>>>
export type GetAgelessMarketingContextSuspenseQueryError = ErrorType<ProblemDetails>


export function useGetAgelessMarketingContextSuspense<TData = Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgelessMarketingContextSuspense<TData = Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgelessMarketingContextSuspense<TData = Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Practice identity, subdomain, active clinics, and brand color for the Ageless Marketing
page when it is viewed without a session.
 */

export function useGetAgelessMarketingContextSuspense<TData = Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError = ErrorType<ProblemDetails>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAgelessMarketingContext>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAgelessMarketingContextSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary The platform's current website-embed state, as the login-free marketing page renders it.
Carries only the enabled flag and the practice's own approved website list — no billing,
contact, or patient-derived data.
 */
export const getSharedWebsiteEmbedSettings = (
    platformId: string,
    params?: GetSharedWebsiteEmbedSettingsParams,
 signal?: AbortSignal
) => {


      return customAxios<DisplayAgelessWebsiteEmbedSettingsResponse>(
      {url: `/api/v1/ageless/marketing/platforms/${platformId}/website-embed-settings`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetSharedWebsiteEmbedSettingsQueryKey = (platformId: string,
    params?: GetSharedWebsiteEmbedSettingsParams,) => {
    return [
    `/api/v1/ageless/marketing/platforms/${platformId}/website-embed-settings`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSharedWebsiteEmbedSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(platformId: string,
    params?: GetSharedWebsiteEmbedSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSharedWebsiteEmbedSettingsQueryKey(platformId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>> = ({ signal }) => getSharedWebsiteEmbedSettings(platformId,params, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSharedWebsiteEmbedSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>>
export type GetSharedWebsiteEmbedSettingsQueryError = ErrorType<ProblemDetails>


export function useGetSharedWebsiteEmbedSettings<TData = Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params: undefined |  GetSharedWebsiteEmbedSettingsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>,
          TError,
          Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSharedWebsiteEmbedSettings<TData = Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetSharedWebsiteEmbedSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>,
          TError,
          Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSharedWebsiteEmbedSettings<TData = Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetSharedWebsiteEmbedSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The platform's current website-embed state, as the login-free marketing page renders it.
Carries only the enabled flag and the practice's own approved website list — no billing,
contact, or patient-derived data.
 */

export function useGetSharedWebsiteEmbedSettings<TData = Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetSharedWebsiteEmbedSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSharedWebsiteEmbedSettingsQueryOptions(platformId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSharedWebsiteEmbedSettingsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(platformId: string,
    params?: GetSharedWebsiteEmbedSettingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSharedWebsiteEmbedSettingsQueryKey(platformId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>> = ({ signal }) => getSharedWebsiteEmbedSettings(platformId,params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSharedWebsiteEmbedSettingsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>>
export type GetSharedWebsiteEmbedSettingsSuspenseQueryError = ErrorType<ProblemDetails>


export function useGetSharedWebsiteEmbedSettingsSuspense<TData = Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params: undefined |  GetSharedWebsiteEmbedSettingsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSharedWebsiteEmbedSettingsSuspense<TData = Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetSharedWebsiteEmbedSettingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSharedWebsiteEmbedSettingsSuspense<TData = Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetSharedWebsiteEmbedSettingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The platform's current website-embed state, as the login-free marketing page renders it.
Carries only the enabled flag and the practice's own approved website list — no billing,
contact, or patient-derived data.
 */

export function useGetSharedWebsiteEmbedSettingsSuspense<TData = Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError = ErrorType<ProblemDetails>>(
 platformId: string,
    params?: GetSharedWebsiteEmbedSettingsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSharedWebsiteEmbedSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSharedWebsiteEmbedSettingsSuspenseQueryOptions(platformId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary The catalog campaign short links (giveaway kit, SMS blast, onboarding shortcut) spelled out
for a practice — every channel crossed with every flow, each with its fixed code and both
URLs. This is what the HubSpot campaign kit renders instead of composing UTMs itself.
 */
export const getAgelessShortLinkCatalog = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<DisplayAgelessShortLinkCatalogResponse>(
      {url: `/api/v1/ageless/marketing/platforms/${platformId}/short-links/catalog`, method: 'GET', signal
    },
      );
    }




export const getGetAgelessShortLinkCatalogQueryKey = (platformId: string,) => {
    return [
    `/api/v1/ageless/marketing/platforms/${platformId}/short-links/catalog`
    ] as const;
    }


export const getGetAgelessShortLinkCatalogQueryOptions = <TData = Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgelessShortLinkCatalogQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>> = ({ signal }) => getAgelessShortLinkCatalog(platformId, signal);





   return  { queryKey, queryFn, enabled: platformId !== null && platformId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAgelessShortLinkCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>>
export type GetAgelessShortLinkCatalogQueryError = ErrorType<unknown>


export function useGetAgelessShortLinkCatalog<TData = Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>,
          TError,
          Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgelessShortLinkCatalog<TData = Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>,
          TError,
          Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgelessShortLinkCatalog<TData = Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The catalog campaign short links (giveaway kit, SMS blast, onboarding shortcut) spelled out
for a practice — every channel crossed with every flow, each with its fixed code and both
URLs. This is what the HubSpot campaign kit renders instead of composing UTMs itself.
 */

export function useGetAgelessShortLinkCatalog<TData = Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAgelessShortLinkCatalogQueryOptions(platformId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAgelessShortLinkCatalogSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError = ErrorType<unknown>>(platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgelessShortLinkCatalogQueryKey(platformId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>> = ({ signal }) => getAgelessShortLinkCatalog(platformId, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAgelessShortLinkCatalogSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>>
export type GetAgelessShortLinkCatalogSuspenseQueryError = ErrorType<unknown>


export function useGetAgelessShortLinkCatalogSuspense<TData = Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError = ErrorType<unknown>>(
 platformId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgelessShortLinkCatalogSuspense<TData = Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgelessShortLinkCatalogSuspense<TData = Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The catalog campaign short links (giveaway kit, SMS blast, onboarding shortcut) spelled out
for a practice — every channel crossed with every flow, each with its fixed code and both
URLs. This is what the HubSpot campaign kit renders instead of composing UTMs itself.
 */

export function useGetAgelessShortLinkCatalogSuspense<TData = Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError = ErrorType<unknown>>(
 platformId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAgelessShortLinkCatalog>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAgelessShortLinkCatalogSuspenseQueryOptions(platformId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Where a short-domain path sends the patient. The aglss.ai Vercel project rewrites
`/{prefix}{slug}/{code}` here with the flow named by the prefix; the answer is a 307 to
the tagged Ageless URL, or 404 when nothing matches, so a mistyped code never becomes
untagged traffic on the landing page.
 */
export const resolveAgelessShortLink = (
    params?: ResolveAgelessShortLinkParams,
 signal?: AbortSignal
) => {


      return customAxios<unknown>(
      {url: `/api/v1/ageless/marketing/short-links/resolve`, method: 'GET',
        params, signal
    },
      );
    }




export const getResolveAgelessShortLinkQueryKey = (params?: ResolveAgelessShortLinkParams,) => {
    return [
    `/api/v1/ageless/marketing/short-links/resolve`, ...(params ? [params] : [])
    ] as const;
    }


export const getResolveAgelessShortLinkQueryOptions = <TData = Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError = ErrorType<void | ProblemDetails>>(params?: ResolveAgelessShortLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getResolveAgelessShortLinkQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof resolveAgelessShortLink>>> = ({ signal }) => resolveAgelessShortLink(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ResolveAgelessShortLinkQueryResult = NonNullable<Awaited<ReturnType<typeof resolveAgelessShortLink>>>
export type ResolveAgelessShortLinkQueryError = ErrorType<void | ProblemDetails>


export function useResolveAgelessShortLink<TData = Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError = ErrorType<void | ProblemDetails>>(
 params: undefined |  ResolveAgelessShortLinkParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolveAgelessShortLink>>,
          TError,
          Awaited<ReturnType<typeof resolveAgelessShortLink>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResolveAgelessShortLink<TData = Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError = ErrorType<void | ProblemDetails>>(
 params?: ResolveAgelessShortLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof resolveAgelessShortLink>>,
          TError,
          Awaited<ReturnType<typeof resolveAgelessShortLink>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResolveAgelessShortLink<TData = Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError = ErrorType<void | ProblemDetails>>(
 params?: ResolveAgelessShortLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Where a short-domain path sends the patient. The aglss.ai Vercel project rewrites
`/{prefix}{slug}/{code}` here with the flow named by the prefix; the answer is a 307 to
the tagged Ageless URL, or 404 when nothing matches, so a mistyped code never becomes
untagged traffic on the landing page.
 */

export function useResolveAgelessShortLink<TData = Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError = ErrorType<void | ProblemDetails>>(
 params?: ResolveAgelessShortLinkParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getResolveAgelessShortLinkQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getResolveAgelessShortLinkSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError = ErrorType<void | ProblemDetails>>(params?: ResolveAgelessShortLinkParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getResolveAgelessShortLinkQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof resolveAgelessShortLink>>> = ({ signal }) => resolveAgelessShortLink(params, signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type ResolveAgelessShortLinkSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof resolveAgelessShortLink>>>
export type ResolveAgelessShortLinkSuspenseQueryError = ErrorType<void | ProblemDetails>


export function useResolveAgelessShortLinkSuspense<TData = Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError = ErrorType<void | ProblemDetails>>(
 params: undefined |  ResolveAgelessShortLinkParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResolveAgelessShortLinkSuspense<TData = Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError = ErrorType<void | ProblemDetails>>(
 params?: ResolveAgelessShortLinkParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useResolveAgelessShortLinkSuspense<TData = Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError = ErrorType<void | ProblemDetails>>(
 params?: ResolveAgelessShortLinkParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Where a short-domain path sends the patient. The aglss.ai Vercel project rewrites
`/{prefix}{slug}/{code}` here with the flow named by the prefix; the answer is a 307 to
the tagged Ageless URL, or 404 when nothing matches, so a mistyped code never becomes
untagged traffic on the landing page.
 */

export function useResolveAgelessShortLinkSuspense<TData = Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError = ErrorType<void | ProblemDetails>>(
 params?: ResolveAgelessShortLinkParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof resolveAgelessShortLink>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getResolveAgelessShortLinkSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






